/*
  TOSSIT footer signup
  ====================
  Posts the footer's own First Name + Email form straight into Klaviyo, so the
  footer can keep the theme's styling instead of embedding a Klaviyo form that
  brings its own layout, image and headline.

  It uses Klaviyo's client subscriptions endpoint, which authenticates with the
  public company id alone — no private key is ever in the theme. The payload
  mirrors what the store's own TOSSITClub form sends, including the same list,
  so a footer signup lands in the same list and triggers the same welcome flow
  (and therefore the same discount code) as the popup.

  The form works without this file: it is a real <form> that falls back to a
  normal Shopify customer submission if the script fails to load.
*/
(function () {
  'use strict';

  // 2025-01-15 is the earliest revision whose client endpoint accepts the
  // `subscriptions` block; older ones reject it outright.
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2025-01-15';

  function message(wrapper, text, ok) {
    var el = wrapper.querySelector('[data-signup-message]');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    el.setAttribute('data-state', ok ? 'success' : 'error');
  }

  function submit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var wrapper = form.closest('[data-tossit-signup]');
    if (!wrapper) return;

    var companyId = wrapper.getAttribute('data-company-id');
    var listId = wrapper.getAttribute('data-list-id');
    // Without both ids there is nothing to post to, so let the browser run the
    // form's normal Shopify submission rather than swallowing the signup.
    if (!companyId || !listId) return;

    event.preventDefault();

    var emailInput = form.querySelector('input[type="email"]');
    var nameInput = form.querySelector('input[data-first-name]');
    var button = form.querySelector('button[type="submit"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var firstName = nameInput ? nameInput.value.trim() : '';

    if (!email) return;

    var properties = { $consent_method: 'Footer Signup', $source: 'Website Footer' };
    if (firstName) properties.$first_name = firstName;

    var profile = {
      email: email,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
      properties: properties
    };
    if (firstName) profile.first_name = firstName;

    var payload = {
      data: {
        type: 'subscription',
        attributes: { profile: { data: { type: 'profile', attributes: profile } } },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    if (button) button.disabled = true;

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (button) button.disabled = false;
        // Klaviyo answers 202 with an empty body on success.
        if (response.status === 202 || response.ok) {
          form.reset();
          message(wrapper, wrapper.getAttribute('data-success') || 'You are in. Check your email.', true);
          return;
        }
        message(wrapper, wrapper.getAttribute('data-error') || 'That did not go through. Please try again.', false);
      })
      .catch(function () {
        if (button) button.disabled = false;
        message(wrapper, wrapper.getAttribute('data-error') || 'That did not go through. Please try again.', false);
      });
  }

  document.addEventListener('submit', submit);
})();
